// @flow
import * as cc from 'common/constants';
import type { Action } from 'store/types';
import type { BillingInfo } from 'modules/advertiser/models';

import * as t from './types';
import type { AuthData, AuthCredentials } from './models/AuthData';
import type { User } from './models/User';

export function setReady(payload: boolean): Action<boolean> {
  return {
    type: t.SET_READY,
    payload,
  };
}

export function authorize(username: string, password: string): Action<AuthCredentials> {
  return {
    type: t.AUTH_USER,
    payload: { username, password },
  };
}

export function authorizeRequested(payload: AuthCredentials): Action<AuthCredentials> {
  return {
    type: t.AUTH_USER_REQUESTED,
    payload,
  };
}

export function authorizeSuccess(payload: AuthData): Action<AuthData> {
  return {
    type: t.AUTH_USER_SUCCESS,
    payload,
  };
}

export function authorizeError(payload: string): Action<string> {
  return {
    type: t.AUTH_USER_ERROR,
    payload,
  };
}

export function unauthorize(): Action<void> {
  return {
    type: t.UNAUTH_USER,
  };
}

export function unauthorizeRequested(): Action<void> {
  return {
    type: t.UNAUTH_USER_REQUESTED,
  };
}

export function unauthorizeSuccess(): Action<void> {
  return {
    type: t.UNAUTH_USER_SUCCESS,
  };
}

export function unauthorizeError(payload: string): Action<string> {
  return {
    type: t.UNAUTH_USER_ERROR,
    payload,
  };
}

export function refreshToken(): Action<void> {
  return {
    type: t.REFRESH_TOKEN,
  };
}

export function refreshTokenRequested(payload: string): Action<string> {
  return {
    type: t.REFRESH_TOKEN_REQUESTED,
    payload,
  };
}

export function refreshTokenSuccess(payload: AuthData): Action<AuthData> {
  return {
    type: t.REFRESH_TOKEN_SUCCESS,
    payload,
  };
}

export function refreshTokenError(payload: string): Action<string> {
  return {
    type: t.REFRESH_TOKEN_ERROR,
    payload,
  };
}

export function breakAccessToken(): Action<void> {
  return { type: t.BREAK_ACCESS_TOKEN };
}

export function fetchUserData(): Action<void> {
  return {
    type: t.FETCH_USER_DATA,
  };
}

export function reloadAuthSession(): Action<void> {
  return {
    type: t.RELOAD_AUTH_SESSION,
  };
}

export function setUserData(app: cc.AppName, user: User) {
  return {
    type: t.SET_USER,
    payload: {
      app,
      user,
    },
  };
}

export function setBillingInfo(payload: BillingInfo): Action<BillingInfo> {
  return {
    type: t.SET_BILLING_INFO,
    payload,
  };
}



// WEBPACK FOOTER //
// ./src/modules/auth/actions.js